import React from 'react'

export const ArrowIcon = (props: React.SVGAttributes<SVGElement>) => {
  return (
    <svg
      {...props}
      className={props.className}
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
    >
      <path d='M12.172,12,9.343,9.172l1.414-1.415L15,12l-4.243,4.243L9.343,14.828Z' />
    </svg>
  )
}
